import ReactToPrint from 'react-to-print';
import { BASE_URL, FRONTEND_URL } from "../../../config/axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { formattedDate, formattedDateLong } from '../../Date';
import numberToWords from 'number-to-words';
import { ExpenseDetailApproved, ExpenseDetailPartialApproved, ExpenseDetailReject, BillAuthentication, ViewBill, TLExpenseApprove, TLExpenseReject, AccountAExpenseApprove, AccountAExpenseReject, AdminExpenseApprove, AdminExpenseReject, AccountAPartialEdit } from './ExpenseSlipComponents';
import { DownloadBulkDocumentsAsZip, formatRoundoff2D, handleAllError, handleErrorToast, renderDangerousHTML } from '../../CustomFunctions';
import { CheckTick, DownloadIcon, Printer } from '../../AllSvg';
import { toast } from 'react-toastify';
import { fetchExistingLetterTemplate, numberToIndianWords } from '../../CustomUtilities';

// const ExpenseSlip = React.forwardRef((props, ref) => {
const ExpenseSlip = React.forwardRef(({ onDataRefresh }, ref) => {

  let { id } = useParams();
  const location = useLocation();
  const opener = location.state ? location.state.opener : "";
  const [expenseDetails, setExpenseDetails] = useState([])
  const [expenseData, setExpenseData] = useState([])
  const [personalData, setPersonalData] = useState({})
  const [imprestData, setImprestData] = useState({})
  const [personData, setPersonData] = useState([])


  const totalImprestAsked = parseFloat(expenseDetails.fooding) + parseFloat(expenseDetails.transportation) + parseFloat(expenseDetails.accomodation) +
    // parseFloat(expenseDetails.other);
    (expenseDetails.other_details?.length > 0
      ? expenseDetails.other_details.reduce((total, other) => total + parseFloat(other.amount || 0), 0)
      : 0);
  const totalImprestAskedWords = numberToWords.toWords(totalImprestAsked ? totalImprestAsked : 0);
  const totalImprestApproved = parseFloat(expenseDetails.approved_fooding) + parseFloat(expenseDetails.approved_transportation) + parseFloat(expenseDetails.approved_accomodation) +
    // parseFloat(expenseDetails.approved_other);
    (expenseDetails.other_details?.length > 0
      ? expenseDetails.other_details.reduce((total, other) => total + parseFloat(other.approved_other || 0), 0)
      : 0);
  // const totalImprestApprovedWords = numberToWords.toWords(totalImprestApproved ? totalImprestApproved : 0);

  const [expenseSum, setExpenseSum] = useState(0)
  const [sum, setSum] = useState(0)
  const [dates, setDates] = useState(0)
  const [amountsApproved, setAmountsApproved] = useState(false)


  const [foodingTotal, setFoodingTotal] = useState(0);
  const [transportationTotal, setTransportationTotal] = useState(0);
  const [accomodationTotal, setAccomodationTotal] = useState(0);
  const [otherTotal, setOtherTotal] = useState(0);

  const [approvedFoodingTotal, setApprovedFoodingTotal] = useState(0);
  const [approvedTransportationTotal, setApprovedTransportationTotal] = useState(0);
  const [approvedAccomodationTotal, setApprovedAccomodationTotal] = useState(0);
  const [approvedOtherTotal, setApprovedOtherTotal] = useState(0);
  const [subCompany, setSubCompany] = useState({});
  const date = formattedDate
  const [letterTemplateData, setLetterTemplateData] = useState({});

  const [buffer, setBuffering] = useState(true); //buffering logic
  const getLetterData = async () => {
    try {
      setBuffering(true); // Start Buffering

      const exp = await axios.get(`${BASE_URL}/wfm/expensebyid/${id}/`);
      setExpenseDetails(exp.data)

      const res = await axios.get(`${BASE_URL}/wfm/expensedetailsbyexpense/${exp.data.id}/`);
      setExpenseData(res.data)
      setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
      setAmountsApproved(res.data.some(expense => expense.bill_approved_amt === null))

      const summ = res.data.some(expense => expense.bill_approved_amt === null)
        ? res.data.reduce((acc, item) => acc + parseFloat(item.item_amount || 0), 0)
        : res.data.reduce((acc, item) => acc + parseFloat(item.bill_approved_amt || 0), 0);
      setSum(summ)

      const expsumm = res.data.reduce((acc, item) => acc + parseFloat(item.item_amount), 0);
      setExpenseSum(expsumm)



      const ress = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${exp.data.empcode}/`)
      setPersonalData(ress.data)

      const resss = await axios.get(`${BASE_URL}/wfm/imprestbyid/${exp.data.imprest}/`)
      setImprestData(resss.data)

      setPersonData(resss.data.multiple_person_details.map(person => person.name));

      res.data.forEach(item => {
        const amount = parseFloat(item.item_amount);
        const approvedAmount = parseFloat(item.bill_approved_amt);
        switch (item.expense_type) {
          case 'fooding':
            setFoodingTotal(prevTotal => prevTotal + amount);
            setApprovedFoodingTotal(prevTotal => prevTotal + approvedAmount);
            break;
          case 'transportation':
            setTransportationTotal(prevTotal => prevTotal + amount);
            setApprovedTransportationTotal(prevTotal => prevTotal + approvedAmount);
            break;
          case 'accomodation':
            setAccomodationTotal(prevTotal => prevTotal + amount);
            setApprovedAccomodationTotal(prevTotal => prevTotal + approvedAmount);
            break;
          // case 'other':
          //   setOtherTotal(prevTotal => prevTotal + amount);
          //   break;
          default:
            setOtherTotal(prevTotal => prevTotal + amount);
            setApprovedOtherTotal(prevTotal => prevTotal + (approvedAmount || 0));
            break;
        }
      });

    } catch (err) {
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getLetterData();

  }, [id]);
  const [checkedItems, setCheckedItems] = useState([]);

  const handleCheckboxChange = (id) => {
    const currentIndex = checkedItems.indexOf(id);
    const newCheckedItems = [...checkedItems];

    if (currentIndex === -1) {
      newCheckedItems.push(id);
    } else {
      newCheckedItems.splice(currentIndex, 1);
    }

    setCheckedItems(newCheckedItems);
  };

  const updatedApprovals = checkedItems.map((id) => {
    return {
      id: id,
    };
  });

  const [loadingBulk, setLoadingBulk] = useState(false); //loading logic
  const handleFormSubmitApprovePut = async (e) => {
    e.preventDefault();
    setLoadingBulk(true); //loading logic

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.put(
        `${BASE_URL}/wfm/bulk-update-expensedetails/tlbillupdate/`,
        updatedApprovals
      );

      if (res.status === 200) {
        setCheckedItems([])
        await getLetterData();
        if (onDataRefresh) await onDataRefresh();
      } else {
        alert(res);
      }
    } catch (err) {
      handleAllError(err)
    } finally {
      setLoadingBulk(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };


  const loadLetterTemplate = async (id) => {

    try {
      const { template, subcompany } = await fetchExistingLetterTemplate({
        letterTemplateId: personalData?.letter_template,
        subcompanyId: id,
        emp_code: expenseDetails?.empcode,
      });
      setLetterTemplateData(template);
      if (subcompany) setSubCompany(subcompany);
    } catch (err) {
      // toast.warning("Could not fetch letter template");
    }
  };

  const formatShortDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear(); // Full 4-digit year - "2025"
    return `${month} ${day}, ${year}`; // Output: "Jan 8, 2025"
  };


  useEffect(() => {
    loadLetterTemplate(expenseDetails?.sub_company);
  }, [expenseDetails?.sub_company, expenseDetails?.empcode, personalData?.letter_template]);


  return (
    <div ref={ref}
      //  className='letter-parent'
      style={{
        width: '210mm',
        position: "relative",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className='letterslip  letterslip-outer' >
        {/* <div className='printSlip-header'>
          <div className='printSlip-header-left'>
            <img src={subCompany?.company_logo}
              alt={subCompany?.title} className='printSlip-logo' />



          </div>

          <div className='printSlip-header-right expenseslip-p' style={{ textAlign: 'right' }} >
            {subCompany?.title && (
              <div className='printSlip-header-right-top  font-weight600   font-size-heading' style={{ marginBottom: '5px' }}>
                {subCompany?.title}
              </div>
            )}
            {subCompany?.company_address && (
              <div style={{ textAlign: 'right' }} dangerouslySetInnerHTML={{ __html: subCompany?.company_address }} />
            )}
          </div>
        </div> */}

        {(letterTemplateData?.header_logo || letterTemplateData?.header_company_name || letterTemplateData?.header_Address || letterTemplateData?.header_email || letterTemplateData?.header_full_image)
          ?
          (
            letterTemplateData?.header_full_image ? (
              <div className='salaryslip-header'
                style={{
                  paddingLeft: `${letterTemplateData?.header_left_gap}px`,
                  paddingRight: `${letterTemplateData?.header_right_gap}px`,
                  paddingTop: `${letterTemplateData?.header_top_gap}px`,
                  paddingBottom: `${letterTemplateData?.header_bottom_gap}px`,

                }}
              >
                <img src={`${letterTemplateData?.header_full_image}`} alt='full Image' className='salaryslip-fullimage increement-s-header-image' />
              </div>
            )
              :
              (
                (letterTemplateData?.header_logo || letterTemplateData?.header_company_name || letterTemplateData?.header_Address || letterTemplateData?.header_email) &&
                (
                  <>
                    <div className='salaryslip-header'
                      style={{
                        paddingLeft: `${letterTemplateData?.header_left_gap}px`,
                        paddingRight: `${letterTemplateData?.header_right_gap}px`,
                        paddingTop: `${letterTemplateData?.header_top_gap}px`,
                        paddingBottom: `${letterTemplateData?.header_bottom_gap}px`,

                      }}
                    >
                      <div className='salaryslip-header-left'>
                        {!letterTemplateData?.header_full_image &&
                          letterTemplateData?.header_logo ? (
                          <img src={`${letterTemplateData?.header_logo}`} alt='logo' className='salaryslip-logo' />
                        ) : (
                          ''
                        )
                        }

                      </div>
                      <div
                        className='salaryslip-header-right text-end'
                      >

                        {
                          letterTemplateData?.header_company_name ? (
                            // <div
                            //   className={`letter-template-header-company`}
                            //   style={{
                            //     color:
                            //       letterTemplateData?.header_primary_colour || "black",
                            //   }}
                            // >
                            <div className={`salaryslip-header-right-top-red font-weight600 font-size-heading`} style={{ color: letterTemplateData?.header_primary_colour || 'black' }}>
                              {letterTemplateData?.header_company_name}
                            </div>
                          ) : ('')}
                        {
                          (letterTemplateData?.header_Address || letterTemplateData?.header_email) && (
                            // <div
                            //   className='letter-template-header-font'
                            //   style={{
                            //     color:
                            //       letterTemplateData?.header_secondery_colour || "black",
                            //   }}>
                            //   {renderDangerousHTML(letterTemplateData?.header_Address)}
                            //   {letterTemplateData?.header_email && letterTemplateData?.header_email}
                            // </div>
                            <>
                              <div style={{ color: letterTemplateData?.header_secondery_colour || '#212529' }} className='salaryslip-header-right-bottom inc-header-address  font-weight400  font-size-subheading letter-address' dangerouslySetInnerHTML={{ __html: letterTemplateData?.header_Address }}>

                              </div>
                              <span className="letter-address" style={{ color: letterTemplateData?.header_secondery_colour || '#212529' }}> {letterTemplateData?.header_email} </span>

                            </>
                          )
                        }
                      </div>
                    </div>
                    {!letterTemplateData?.header_full_image && (<div className='salaryslip-hr mb-2'></div>)}
                  </>
                )
              )
          ) :
          (
            <>
              <div className='salaryslip-header' style={{ padding: '10px' }}>
                {subCompany?.company_logo && (
                  <div className='salaryslip-header-left'>
                    <img src={subCompany?.company_logo} alt={subCompany?.title} className='salaryslip-logo' />
                  </div>
                )}
                <div className='salaryslip-header-right'>
                  {subCompany?.company_name && (
                    <div className='printSlip-header-right-top  font-weight600   font-size-heading' style={{ marginBottom: '5px', textAlign: 'end' }}>
                      {subCompany?.company_name}
                    </div>
                  )}
                  <div className='salaryslip-header-right-bottom  font-weight400  font-size-subheading'>
                    {subCompany?.company_address && (
                      // <div className='slip-top-right-content' style={{ textAlign: 'right' }} dangerouslySetInnerHTML={{ __html: subCompany?.company_address }} />
                      <div className='slip-top-right-content'>
                        {renderDangerousHTML(subCompany?.company_address)}
                      </div >
                    )}
                  </div>
                </div>
              </div>
              <div className='salaryslip-hr'></div>
            </>
          )
        }

        <div className='content-container'
          style={{
            paddingLeft: `${letterTemplateData?.content_left_gap}px`,
            paddingRight: `${letterTemplateData?.content_right_gap}px`,
            paddingTop: !letterTemplateData?.id && '20px',
            paddingBottom: !letterTemplateData?.id && '20px',
            overflow: 'hidden',
            wordWrap: "break-word",
            // minHeight: '165vh',
            // height: 'auto'
          }}>
          <div className='printSlip-header-left-text  font-size-heading' style={{ padding: '2px 19px' }}>
            Expense Slip For : "{expenseDetails?.name}"
          </div>
          {/* <div className='printSlip-hr hr-line' ></div> */}
          {/* <div className='printSlip-header-second'>
            <div className='printSlip-header-second-section1'>
              <div className='printSlip-heading-black   font-weight600 font-size-subheading'>Project Name</div>
              <div className='printSlip-heading-black   font-weight600 font-size-subheading'>Employee Code</div>
              <div className='printSlip-heading-black   font-weight600 font-size-subheading'>Department</div>
            </div>
            <div className='printSlip-header-second-section2'>
              <div className='printSlip-heading-black1  font-weight400  font-size-subheading'>{expenseDetails.project_name}</div>
              <div className='printSlip-heading-black1  font-weight400  font-size-subheading'>{expenseDetails.empcode}</div>
              <div className='printSlip-heading-black1  font-weight400  font-size-subheading'>{personalData.department_name}</div>
            </div>
            <div className='printSlip-header-second-section3'>
            </div>
            <div className='printSlip-header-second-section4'>
              <div className='printSlip-heading-black   font-weight600 font-size-subheading'>Name</div>
              <div className='printSlip-heading-black   font-weight600 font-size-subheading'>Start Date</div>
              <div className='printSlip-heading-black   font-weight600 font-size-subheading'>End Date</div>
            </div>
            <div className='printSlip-header-second-section5'>
              <div className='printSlip-heading-black1  font-weight400  font-size-subheading'>{personalData.name}</div>
              <div className='printSlip-heading-black1  font-weight400  font-size-subheading'>{dates.length == 0 ? "Expense Details Pending " : formattedDateLong(dates[0])}</div>
              <div className='printSlip-heading-black1  font-weight400  font-size-subheading'>{dates.length == 0 ? "Expense Details Pending " : formattedDateLong(dates[dates.length - 1])}</div>
            </div>
          </div> */}


          <div className="slip-info-wrapper">

            <div className="slip-col slip-col-left">
              <div className="rows">
                <span className="label">Project Name:</span>
                <span className="value">{expenseDetails.project_name}</span>
              </div>

              <div className="rows">
                <span className="label">Employee Code:</span>
                <span className="value">{expenseDetails.empcode}</span>
              </div>

              <div className="rows">
                <span className="label">Department:</span>
                <span className="value">{personalData.department_name}</span>
              </div>
            </div>

            <div className="slip-col slip-col-right">
              <div className="rows">
                <span className="label">Name:</span>
                <span className="value">{personalData.name}</span>
              </div>

              <div className="rows">
                <span className="label">Start Date:</span>
                <span className="value">
                  {dates.length === 0 ? "Expense Pending" : formattedDateLong(dates[0])}
                </span>
              </div>

              <div className="rows">
                <span className="label">End Date:</span>
                <span className="value">
                  {dates.length === 0 ? "Expense Pending" : formattedDateLong(dates[dates.length - 1])}
                </span>
              </div>
            </div>

          </div>





          <div className='printSlip-body'>
            <tr>
              <th className='printSlip-heading-blue font-weight500 font-size-subheading'>Imprest: </th>
              {/* <td colSpan={5} style={{ paddingLeft: "30px" }} className='text-capitalize'>{totalImprestAskedWords}</td> */}
            </tr>

            <table className='printSlip-table' style={{
              width: '100%',
              borderCollapse: 'collapse',
              tableLayout: 'auto'
            }}>
              <thead style={{ margin: "20px 0px" }}>
                <tr className='printSlip-head' style={{
                  padding: "8px 5px",
                  width: "5%",
                  wordBreak: "break-word",
                  textAlign: "center"
                }}>
                  <th style={{
                    padding: "10px 5px",
                    width: "80px",
                    minWidth: "80px",
                    textAlign: "center",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'></th>
                  {imprestData.fooding !== "0" && <th style={{
                    padding: "10px 5px",
                    minWidth: "70px",
                    textAlign: "right",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Fooding</th>}
                  {imprestData.transportation !== "0" && <th style={{
                    padding: "10px 5px",
                    minWidth: "70px",
                    textAlign: "right",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Traveling</th>}
                  {imprestData.accomodation !== "0" && <th style={{
                    padding: "10px 5px",
                    minWidth: "70px",
                    textAlign: "right",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Accomodation</th>}
                  {imprestData.other_details?.length > 0
                    ?
                    <>
                      {imprestData.other_details.map((other, index) => (
                        <th style={{
                          padding: "10px 5px",
                          minWidth: "70px",
                          maxWidth: "110px",
                          textAlign: "right",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "normal",
                          lineHeight: "1.3",
                          backgroundColor: "#e9ecef"
                        }} className='printSlip-table-td text-capitalize'>{other.other_name ? other.other_name : `Other-${index + 1}`}</th>
                      ))}
                    </>
                    : null}
                  <th style={{
                    padding: "5px 5px",
                    minWidth: "70px",
                    textAlign: "right",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Grand Total</th>
                </tr>
              </thead>
              <tbody>
                <React.Fragment>
                  <tr>
                    <td style={{
                      padding: "5px 5px",
                      // textAlign: "center",
                      fontWeight: "500",
                      // backgroundColor: "#f8f9fa"
                    }} className='printSlip-heading-blue font-weight500 font-size-subheading'>Asked</td>
                    {imprestData.fooding !== "0" && <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(imprestData.fooding)}</td>}
                    {imprestData.transportation !== "0" && <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(imprestData.transportation)}</td>}
                    {imprestData.accomodation !== "0" && <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(imprestData.accomodation)}</td>}
                    {/* <td className='printSlip-table-td'>{imprestData.other}</td> */}
                    {imprestData.other_details?.length > 0
                      ?
                      imprestData.other_details?.map((other, index) => (
                        <td style={{
                          padding: "5px 5px",
                          textAlign: "right",
                          wordBreak: "break-word",
                          cursor: 'help'
                        }} className='printSlip-table-td'>{formatRoundoff2D(other.amount) || 0}</td>
                      ))
                      : null}
                    <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word",
                      fontWeight: "500"
                    }} className='printSlip-table-td '>{formatRoundoff2D(totalImprestAsked)}</td>
                  </tr>
                  {/* <tr>
                  <td colSpan={6} className='printSlip-hrr'></td>
                </tr> */}
                  <tr>
                    <td style={{
                      // padding: "10px 5px",
                      // textAlign: "center",
                      // fontWeight: "500",
                      // backgroundColor: "#f8f9fa"
                      padding: "5px 5px",
                      width: "80px",
                      minWidth: "80px",
                      // textAlign: "center",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                    }} className='printSlip-heading-blue font-weight500 font-size-subheading'>Approved</td>
                    {imprestData.approved_fooding !== "0" && <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(imprestData.approved_fooding)}</td>}
                    {imprestData.approved_transportation !== "0" && <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(imprestData.approved_transportation)}</td>}
                    {imprestData.approved_accomodation !== "0" && <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(imprestData.approved_accomodation)}</td>}
                    {/* <td className='printSlip-table-td'>{imprestData.approved_other}</td> */}
                    {imprestData.other_details?.length > 0
                      ?
                      imprestData.other_details?.map((other, index) => (
                        <td style={{
                          padding: "5px 5px",
                          textAlign: "right",
                          wordBreak: "break-word",
                          cursor: 'help'
                        }} className='printSlip-table-td'>{formatRoundoff2D(other.approved_other) || 0}</td>
                      ))
                      : null}
                    <td style={{
                      padding: "5px 5px",
                      textAlign: "right",
                      wordBreak: "break-word",
                      fontWeight: "500"
                    }} className='printSlip-table-td '>{formatRoundoff2D(totalImprestApproved)}</td>
                  </tr>

                </React.Fragment>

                <tr>
                  <td colSpan={7} className='printSlip-hrr'></td>
                </tr>

              </tbody>
            </table>
            {/* <br /> */}
            <tr style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', gap: '24px' }}>
                <th style={{
                  padding: "5px",
                  width: "120px",
                  textAlign: "left",
                  fontWeight: "600"
                }}>Grand Total</th>
                <td style={{
                  padding: "5px",
                  textAlign: "center",
                  // fontWeight: "600"
                }} colSpan={5} className='text-capitalize'>{formatRoundoff2D(totalImprestApproved)}</td>
              </div>
              <div style={{ display: 'flex', gap: '24px' }}>
                <th style={{
                  padding: "5px",
                  width: "120px",
                  textAlign: "left",
                  fontWeight: "600",
                  verticalAlign: "top"
                }}>IN WORDS</th>
                <td colSpan={5} style={{
                  padding: "5px",
                  textAlign: "left",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  lineHeight: "1.5"
                }} className='text-capitalize'>{numberToIndianWords(totalImprestApproved || 0)}</td>
              </div>
            </tr>
            {/* <br /> */}
            <table className='printSlip-table' style={{
              width: '100%',
              borderCollapse: 'collapse',
              tableLayout: 'fixed'
            }}>
              <thead>
                <tr>
                  <th colSpan={7}
                    style={{
                      padding: "8px 5px",
                      textAlign: "left",
                      // backgroundColor: "#f5f5f5"
                    }} className='printSlip-heading-blue font-weight500 font-size-subheading'>Expense: </th>
                  {/* <th>Expense Asked : </th> */}
                  {/* <td colSpan={5} style={{ paddingLeft: "30px" }} className='text-capitalize'>{totalImprestApprovedWords}</td> */}
                </tr>
                {/* <tr className='printSlip-head'>
                  <th style={{ padding: "0px 5px" }} >Employee name</th>
                  <th style={{ padding: "0px 5px" }} className='printSlip-table-td'></th>
                  <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Fooding</th>
                  <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Traveling</th>
                  <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Accomodation</th>
                  <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Others</th>
                  <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Grand Total</th>
                </tr> */}
                <tr className='printSlip-head'>
                  <th style={{
                    padding: "10px 5px",
                    width: "25%",
                    textAlign: "left",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} >Employee name</th>
                  <th style={{
                    padding: "10px 5px",
                    width: "10%",
                    textAlign: "center",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'></th>
                  <th style={{
                    padding: "10px 5px",
                    width: "12%",
                    textAlign: "right",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Fooding</th>
                  <th style={{
                    padding: "10px 5px",
                    width: "12%",
                    textAlign: "right",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Traveling</th>
                  <th style={{
                    padding: "10px 5px",
                    width: "12%",
                    textAlign: "right",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Accomodation</th>
                  <th style={{
                    padding: "10px 5px",
                    width: "12%",
                    textAlign: "right",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Others</th>
                  <th style={{
                    padding: "10px 5px",
                    // width: "17%",
                    minWidth: "85px",
                    textAlign: "right",
                    wordBreak: "break-word",
                    backgroundColor: "#e9ecef"
                  }} className='printSlip-table-td'>Grand Total</th>
                </tr>
              </thead>
              <tbody>
                <React.Fragment>
                  <tr>
                    {/* <td className='printSlip-heading-blue font-weight500 font-size-subheading' style={{ width: '200px' }}>{personData}</td> */}
                    <td rowSpan={2} style={{
                      padding: "10px 5px",
                      width: "25%",
                      textAlign: "left",
                      verticalAlign: "top",
                      wordBreak: "break-word",
                      // backgroundColor: "#f8f9fa",
                      fontWeight: "500"
                    }} className='printSlip-heading-blue font-weight500 font-size-subheading'>
                      {personData.map((name, index) => (
                        <React.Fragment key={index}>
                          {name},
                          {index !== personData.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "center",
                      fontWeight: "500",
                      // backgroundColor: "#f8f9fa"
                    }} className='printSlip-heading-blue font-weight500 font-size-subheading'>Asked</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(foodingTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(transportationTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(accomodationTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word",
                      cursor: 'help'
                    }} className='printSlip-table-td'

                      title={expenseData
                        .filter(other => !['fooding', 'transportation', 'accomodation'].includes(other.expense_type))
                        .map((other, index) => `${other.item_name} (${other.expense_type}) : ${formatRoundoff2D(other.item_amount)}`)
                        .join('\n')
                      }
                    >{formatRoundoff2D(otherTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word",
                      fontWeight: "500"
                    }} className='printSlip-table-td '>{formatRoundoff2D(expenseSum)}</td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "center",
                      fontWeight: "500",
                      // backgroundColor: "#f8f9fa"
                    }} className='printSlip-heading-blue font-weight500 font-size-subheading'>Approved</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(approvedFoodingTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(approvedTransportationTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word"
                    }} className='printSlip-table-td'>{formatRoundoff2D(approvedAccomodationTotal)}</td>
                    <td className='printSlip-table-td'
                      style={{
                        padding: "10px 5px",
                        textAlign: "right",
                        wordBreak: "break-word",
                        cursor: 'help'
                      }}
                      title={expenseData
                        .filter(other => !['fooding', 'transportation', 'accomodation'].includes(other.expense_type))
                        .map((other, index) => `${other.item_name} (${other.expense_type}) : ${formatRoundoff2D(other.bill_approved_amt)}`)
                        .join('\n')
                      }
                    >{formatRoundoff2D(approvedOtherTotal)}</td>
                    <td style={{
                      padding: "10px 5px",
                      textAlign: "right",
                      wordBreak: "break-word",
                      fontWeight: "500"
                    }} className={`printSlip-table-td ${amountsApproved ? 'request-status' : ''}`} request-status={amountsApproved ? 'pending' : ''} >{amountsApproved ? "Approvals Pending" : formatRoundoff2D(sum)}</td>
                  </tr>
                </React.Fragment>
                <br />

                <tr>
                  <td colSpan={7} className='printSlip-hrr'></td>
                </tr>
              </tbody>
            </table>

            <table
              className='printSlip-table'
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                tableLayout: 'fixed'
              }}
            >
              <thead style={{ margin: "20px 0px" }}>
                <tr className='printSlip-head'>
                  <th style={{
                    padding: "8px 5px",
                    width: "5%",
                    wordBreak: "break-word",
                    textAlign: "center"
                  }} className='printSlip-table-td'>Sr No.</th>
                  <th style={{
                    padding: "8px 5px",
                    width: "14%",
                    wordBreak: "break-word",
                    textAlign: "center"
                  }} className='printSlip-table-td'>Date</th>
                  <th style={{
                    padding: "8px 5px",
                    width: "23%",
                    wordBreak: "break-word",
                    textAlign: "left"
                  }} className='printSlip-table-td'>Name</th>
                  <th style={{
                    padding: "8px 5px",
                    width: "10%",
                    wordBreak: "break-word",
                    textAlign: "right"
                  }} className='printSlip-table-td'>Amount</th>
                  {opener === "tl" && expenseDetails?.rh_status === "pending" &&
                    expenseData?.some(item => !item?.bill_approved_amt) ?
                    <th style={{
                      padding: "8px 5px",
                      width: "8%",
                      textAlign: "center"
                    }} className='printSlip-table-td hide-on-print'>
                      {checkedItems?.length > 0 ?
                        <button
                          className="model-edit-button-ml"
                          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          onClick={handleFormSubmitApprovePut}
                          disabled={loadingBulk}
                        >
                          <CheckTick />
                        </button>
                        :
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          checked={(checkedItems?.length > 0) ? true : false}
                          onChange={(e) => {
                            if (e.target.checked) {
                              const filteredIds = expenseData
                                ?.filter((data) => {
                                  return !data?.bill_approved_amt;
                                })?.map((data) => data?.id) || [];
                              setCheckedItems(filteredIds);
                            } else {
                              setCheckedItems([]);
                            }
                          }}
                        />
                      }
                    </th> : null}
                  <th style={{
                    padding: "8px 5px",
                    width: "12%",
                    wordBreak: "break-word",
                    textAlign: "right"
                  }} className='printSlip-table-td'>Approved Amt.</th>
                  <th style={{
                    padding: "8px 5px",
                    width: "12%",
                    wordBreak: "break-word",
                    textAlign: "center"
                  }} className='printSlip-table-td'>Expense Type</th>
                  <th style={{
                    padding: "8px 5px",
                    width: "12%",
                    wordBreak: "break-word",
                    textAlign: "center"
                  }} className='printSlip-table-td'>Bills</th>
                </tr>
              </thead>

              <tbody>
                {expenseData && expenseData?.length > 0 ? (
                  expenseData
                    ?.sort((a, b) => new Date(a?.date) - new Date(b?.date))
                    ?.map((j, index) => (
                      <React.Fragment key={index}>
                        <tr className="tr-border-bottom">
                          <td colSpan="8" style={{ padding: 0 }}></td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #dee2e6" }}>
                          <td style={{
                            padding: "8px 5px",
                            textAlign: 'center',
                            wordBreak: 'break-word'
                          }} className='printSlip-table-td'>
                            {index + 1}
                          </td>
                          <td style={{
                            padding: "8px 5px",
                            textAlign: 'left',  // Left align for better readability
                            wordBreak: 'keep-all',
                            whiteSpace: 'nowrap'
                          }} className='printSlip-table-td'>
                            {/* {formattedDateLong(j?.date)} */}
                            {formatShortDate(j?.date)}
                          </td>
                          <td
                            style={{
                              padding: "8px 5px",
                              wordBreak: 'break-word',
                              overflowWrap: 'break-word',
                              whiteSpace: 'normal',
                              lineHeight: '1.4'
                            }}
                            className='printSlip-table-td'
                            title={j?.item_name || ""}
                          >
                            {j?.item_name || "-"}
                          </td>
                          <td style={{
                            padding: "8px 5px",
                            textAlign: 'right',
                            wordBreak: 'break-word'
                          }} className='printSlip-table-td'>
                            {formatRoundoff2D(j?.item_amount || 0)}
                          </td>
                          {opener === "tl" && expenseDetails?.rh_status === "pending" &&
                            expenseData?.some(item => !item?.bill_approved_amt) ?
                            <td style={{
                              padding: "8px 5px",
                              textAlign: 'center'
                            }} className='printSlip-table-td hide-on-print'>
                              {buffer ? <div className="spinner-vsmall"></div> :
                                j?.bill_approved_amt
                                  ?
                                  <span className='align-center'>-</span>
                                  : <input
                                    className="form-checkbox"
                                    type="checkbox"
                                    checked={checkedItems?.includes(j?.id)}
                                    onChange={() => handleCheckboxChange(j?.id)}
                                  />}
                            </td> : null}
                          <td
                            style={{
                              padding: "8px 5px",
                              textAlign: 'right',
                              wordBreak: 'break-word'
                            }}
                            className='printSlip-table-td align-center'
                            title={`${j?.bill_amount_change_reason ? `Amount Change Reason: \n${j?.bill_amount_change_reason}` : ""}`}
                          >
                            {j?.bill_approved_amt ?
                              j?.bill_approved_amt === "0" && j?.bill_approved === "rejected" ?
                                <span title={`${j?.bill_amount_change_reason ? `Amount Change Reason: \n${j?.bill_amount_change_reason}\n` : ""}${j?.bill_approved === "rejected" ? `Bill Reject Reason: \n${j?.bill_rejection_reason}` : ""}`} style={{ textDecoration: 'line-through' }}>{formatRoundoff2D(j?.tl_approved_amt || 0)}</span>
                                : formatRoundoff2D(j?.bill_approved_amt || 0)
                              :
                              opener === "tl" && expenseDetails?.rh_status === "pending" ?
                                buffer ? <div className="spinner-vsmall"></div> :
                                  <div style={{ display: "flex", alignItems: 'center', justifyContent: 'flex-end', gap: "4px" }}>
                                    {/* <ExpenseDetailApproved i={j} getExpensedetail={getLetterData} />
                                    <ExpenseDetailPartialApproved i={j} getExpensedetail={getLetterData} /> */}
                                    <ExpenseDetailApproved i={j} getExpensedetail={getLetterData} onDataRefresh={onDataRefresh} />
                                    <ExpenseDetailPartialApproved i={j} getExpensedetail={getLetterData} onDataRefresh={onDataRefresh} />
                                  </div>
                                :
                                "-"
                            }
                          </td>
                          <td style={{
                            padding: "8px 5px",
                            textAlign: 'center',
                            wordBreak: 'break-word'
                          }} className='printSlip-table-td'>
                            {j?.expense_type || "-"}
                          </td>
                          <td style={{
                            padding: "8px 5px",
                            textAlign: 'center'
                          }} className='printSlip-table-td'>
                            {j?.bill ?
                              opener === "acc" && expenseDetails?.account_status_a === "pending" ?
                                buffer ? <div className="spinner-vsmall"></div> :
                                  <BillAuthentication i={j} getExpenseDetail={getLetterData} onDataRefresh={onDataRefresh} />
                                :
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", flexWrap: "wrap" }}>
                                  <ViewBill i={j} />
                                  {expenseDetails?.account_status_a !== "pending" ?
                                    j?.bill_approved !== "pending" ?
                                      j?.bill_approved === "approved" ?
                                        <span title='Bill Approved' style={{ marginLeft: '8px' }}>✅</span>
                                        : <span title={`Bill Rejection Reason : ${j?.bill_rejection_reason}`} style={{ marginLeft: '8px' }}>❌</span>
                                      :
                                      <input
                                        type="checkbox"
                                        checked={false}
                                        readOnly
                                        className="form-checkbox"
                                      />
                                    : null
                                  }
                                </div>
                              : " No bill"}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ padding: "20px", textAlign: "center" }}>
                      No expense data available
                    </td>
                  </tr>
                )}
                <tr>
                  <td colSpan={8} className='printSlip-hrr'></td>
                </tr>
              </tbody>
            </table>

            <tr style={{
              borderTop: "1px solid #dee2e6",
              borderBottom: "1px solid #dee2e6"
            }}>
              <th style={{
                padding: "5px",
                width: "120px",
                textAlign: "left",
                fontWeight: "600"
              }}>
                TOTAL
              </th>
              <td style={{
                padding: "5px",
                textAlign: "center",
                fontWeight: "600"
              }} colSpan={5}>
                {formatRoundoff2D(sum)}
              </td>
            </tr>

            {/* IN WORDS ROW */}
            <tr>
              <th
                style={{
                  padding: "5px",
                  width: "120px",
                  textAlign: "left",
                  fontWeight: "600",
                  verticalAlign: "top"
                }}
                className='printSlip-heading-blue font-weight500 font-size-subheading'
              >
                IN WORDS
              </th>
              <td
                colSpan={5}
                style={{
                  padding: "5px",
                  textAlign: "left",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  lineHeight: "1.5"
                }}
                className='text-capitalize'
              >
                {numberToIndianWords(sum || 0)}
              </td>
            </tr>
          </div>
          {/* <div className='printSlip-hr'></div> */}
          <br />
          <h6 style={{ fontSize: '10px' }}><b>*This is Software generated Expense Slip no signature required*</b></h6>

        </div>

        {!letterTemplateData?.footer_full_image && (<div className='salaryslip-hr'></div>)}
        {
          letterTemplateData?.footer_full_image && (
            <div className='salaryslip-header salaryslip-footer'
              style={{
                paddingLeft: `${letterTemplateData?.footer_left_gap}px`,
                paddingRight: `${letterTemplateData?.footer_right_gap}px`,
                paddingTop: `${letterTemplateData?.footer_top_gap}px`,
                paddingBottom: `${letterTemplateData?.footer_bottom_gap}px`,
                position: 'absolute',
                // bottom: '0',
                width: '-webkit-fill-available',
                backgroundColor: 'white'
              }}
            >
              <img src={`${letterTemplateData?.footer_full_image}`} alt='full Image' className='salaryslip-fullimage increement-s-header-image' />
            </div>
          )
        }


        {
          (letterTemplateData?.footer_logo || letterTemplateData?.footer_company_name || letterTemplateData?.footer_Address || letterTemplateData?.footer_email) &&

          <div className='salaryslip-header salaryslip-footer'
            style={{
              paddingLeft: `${letterTemplateData?.footer_left_gap}px`,
              paddingRight: `${letterTemplateData?.footer_right_gap}px`,
              paddingTop: `${letterTemplateData?.footer_top_gap}px`,
              paddingBottom: `${letterTemplateData?.footer_bottom_gap}px`,
              position: 'absolute',
              width: '-webkit-fill-available',
              backgroundColor: 'white'
            }}
          >
            <div className='salaryslip-header-left'>
              {!letterTemplateData?.footer_full_image && letterTemplateData?.footer_logo ? (
                <img src={letterTemplateData?.footer_logo} alt='logo' className='salaryslip-logo' />
              ) : (
                <div></div>
              )}
            </div>

            <div className='salaryslip-header-right text-end'>
              {letterTemplateData?.footer_company_name && (
                <div className='salaryslip-header-right-top-red font-weight600 font-size-heading' style={{ color: letterTemplateData?.footer_primary_colour || 'black' }}>
                  {letterTemplateData?.footer_company_name}
                </div>
              )}

              {(letterTemplateData?.footer_Address || letterTemplateData?.footer_email) && (
                <>
                  <div style={{ color: letterTemplateData?.footer_secondery_colour || '#212529' }} className='salaryslip-header-right-bottom inc-header-address  font-weight400 font-size-subheading letter-address' dangerouslySetInnerHTML={{ __html: letterTemplateData?.footer_Address }} >
                  </div>
                  <span className="letter-address" style={{ color: letterTemplateData?.footer_secondery_colour || '#212529' }}> {letterTemplateData?.footer_email}</span>
                </>
              )}
            </div>
          </div>
        }

      </div>
      {letterTemplateData?.bg_image ? (
        <div
          className="aimantra-bg-letter"
          style={{
            backgroundImage: `url(${letterTemplateData?.bg_image})`,
            backgroundSize: `${letterTemplateData?.bg_size}%`,
            backgroundRepeat: 'no-repeat',
            opacity: `${letterTemplateData?.bg_opacity || 100}%`,
            transform: letterTemplateData.bg_angle
              ? `rotate(${letterTemplateData.bg_angle}deg)`
              : "none",
          }}
        ></div>
      )
        :
        (
          <div
            className="aimantra-bg-letter"
            style={{ backgroundImage: `url(${subCompany?.company_logo})` }}
          >
          </div>
        )
      }
      {/* 
      <div
        className="aimantra-bg-letter"
        style={{ backgroundImage: `url(${subCompany?.company_logo})` }}
      >
      </div> */}
    </div >
  )
});


const ExpenseSlipByRequest = () => {
  let { id } = useParams();
  const location = useLocation();
  const opener = location.state ? location.state.opener : "";
  const filter_fromdate = location.state ? location.state.filter_fromdate : "";
  const filter_todate = location.state ? location.state.filter_todate : "";
  const filter_status = location.state ? location.state.filter_status : "";
  const filter_employee = location.state ? location.state.filter_employee : "";
  const filter_subCompany = location.state ? location.state.filter_subCompany : "";
  const filter_department = location.state ? location.state.filter_department : "";
  const filter_empstatus = location.state ? location.state.filter_empstatus : "";
  const filter_selectedProject = location.state ? location.state.filter_selectedProject : "";
  const filter_expenseDateSorting = location.state ? location.state.filter_expenseDateSorting : "";
  const filter_expenseAmountSorting = location.state ? location.state.filter_expenseAmountSorting : "";

  const ref = useRef();
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  let backUrl = "/" + urlParts[3] + `/wfm`;
  let accfirsttoggle = 2;
  let firsttoggle = 1;
  let secondtoggle = 1;
  // console.log("location")
  // console.log(location)
  // console.log(location.state)
  if (opener === "tl") {
    firsttoggle = 4;
    secondtoggle = 5;
    backUrl = "/" + urlParts[3] + `/teamRequestManagement`;
  }
  else if (opener === "admin") {
    firsttoggle = 5;
    // secondtoggle = 6;
    secondtoggle = 2;
    backUrl = "/" + urlParts[3] + `/adminRequestManagement`;
  }
  else if (opener === "acc") {
    accfirsttoggle = 2;
    backUrl = "/" + urlParts[3] + `/imprestExpenseRequestManagement`;
  }
  else if (opener === "accb") {
    accfirsttoggle = 3;
    backUrl = "/" + urlParts[3] + `/imprestExpenseRequestManagement`;
  }
  const backroute = (firsttoggle, secondtoggle, accfirsttoggle) => {
    navigate(backUrl, {
      state: {
        firsttoggle, secondtoggle, accfirsttoggle,
        filter_fromdate,
        filter_todate,
        filter_status,
        filter_employee,
        filter_subCompany,
        filter_department,
        filter_empstatus,
        filter_selectedProject,
        filter_expenseDateSorting,
        filter_expenseAmountSorting,
      }
    })
  }

  const [empData, setEmployeeData] = useState({})
  const [expenseDetails, setExpenseDetails] = useState([])
  const [expenseDataDetails, setExpenseDataDetails] = useState([])

  const [amountsApproved, setAmountsApproved] = useState(false)
  const [billAuthenticated, setBillAuthenticated] = useState(false)

  const [buffer, setBuffering] = useState(true); //buffering logic

  const getExpenseData = async () => {
    setBuffering(true); // Start Buffering
    try {
      const exp = await axios.get(`${BASE_URL}/wfm/expensebyid/${id}/`);
      setExpenseDetails(exp.data)

      const expdeat = await axios.get(`${BASE_URL}/wfm/expensedetailsbyexpense/${exp.data.id}/`);
      setExpenseDataDetails(expdeat.data)
      setAmountsApproved(expdeat.data.some(expense => expense.bill_approved_amt === null))
      setBillAuthenticated(expdeat.data.some(expense => expense.bill_approved === "pending"))

      const emp = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${exp.data.empcode}/`)
      setEmployeeData(emp.data)
    } catch (err) {
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  useEffect(() => {
    getExpenseData();
  }, []);
  return (

    <div className='flex-column flex-center slip-container' style={{ minHeight: '400vh' }}>
      <div className='printSlip-width flex-row justify-evenly button-margin'>
        {/* <div className='printSlip-width flex-row justify-evenly'> */}
        <div></div>
        <button
          className="model-button  font-weight500 model-button-cancel font-size-heading"
          onClick={(e) => { backroute(firsttoggle, secondtoggle, accfirsttoggle) }}>
          Back
        </button>
        <ReactToPrint
          bodyClass="print-agreement"
          content={() => ref.current}
          trigger={() => (
            <button className='model-button model-button-black'>
              <Printer /> Print
            </button>
          )}
        />
        <DownloadBulkDocumentsAsZip
          id='DownloadFilesZip'
          emp_code={empData?.emp_code}
          emp_name={empData?.name}
          document_list={expenseDataDetails}
          doc_name_key={'item_name'}
          doc_file_key={'bill'}
        />
      </div>

      {buffer ? <div className="spinner"></div>
        :
        <>
          {opener === "tl" && expenseDetails.rh_status === "pending" ?
            <div className='printSlip-width flex-row justify-evenly' style={{ marginBottom: '10px' }} >
              <TLExpenseReject i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
              {amountsApproved ?
                "For Approval Please Confirm All Bill Amounts First"
                :
                <TLExpenseApprove i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
              }
            </div>
            :
            <span request-status={expenseDetails.rh_status} className="request-status align-center">Already Performed Action : TL {expenseDetails.rh_status}</span>
          }
          <br />
          {opener === "acc" && expenseDetails.account_status_a === "pending" ?

            // <div className='printSlip-width flex-row justify-evenly' >
            //   <AccountAExpenseReject i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
            //   <AccountAPartialEdit i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
            //   {billAuthenticated ?
            //     "For Approval Please Complete All  Bill Authentication First"
            //     :
            //     <AccountAExpenseApprove i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />}
            // </div>
            <>
              <div className='printSlip-width flex-row justify-evenly' style={{ marginBottom: '10px' }} >
                <AccountAExpenseReject i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
                <AccountAPartialEdit i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} backUrl={backUrl} accfirsttoggle={accfirsttoggle} />
                {billAuthenticated ?
                  null
                  :
                  <AccountAExpenseApprove i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />}
              </div>
              <br />
              {billAuthenticated ?
                <div className="align-center">For Approval Please Complete All Bill Authentication First</div>
                :
                null}
            </>
            : expenseDetails.rh_status !== "pending" ? <span request-status={expenseDetails.account_status_a} className="request-status align-center">Already Performed Action : Bills by Accounts {expenseDetails.account_status_a}</span> : null
          }
          <br />
          {opener === "admin" && expenseDetails.admin_status === "pending" ?

            <div className='printSlip-width flex-row justify-evenly' style={{ marginBottom: '10px' }} >
              <AdminExpenseReject i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
              <AdminExpenseApprove i={expenseDetails} j={expenseDataDetails} getExpenseData={getExpenseData} />
            </div>
            : expenseDetails.account_status_a !== "pending" ?
              <span request-status={expenseDetails.admin_status} className="request-status align-center">Already Performed Action : Admin {expenseDetails.admin_status}</span> : null
          }
        </>
      }
      {/* <ExpenseSlip ref={ref} /> */}
      <ExpenseSlip ref={ref} onDataRefresh={getExpenseData} />
    </div>
  );
};


export default ExpenseSlipByRequest